import { Component, Input, ChangeDetectionStrategy, AfterContentChecked } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Person } from '@/interfaces/person';
import { CompleteUserData } from '@/interfaces/my-profile/my-profile';
import { InfrigmentOfUser } from '@/interfaces/infractions';
import { ofuscate } from '@/utils/obfuscation';

// position debe ser mapeado a un nombre mas bonito

export enum BoxColors {
  WHITE = 'box--white',
  BROWN_GREY = ''
}

@Component({
  selector: 'app-person-card',
  templateUrl: './person-card.component.html',
  styleUrls: ['./person-card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonCardComponent implements AfterContentChecked {
  @Input() personData: Partial<Person> = {};
  @Input() boxColor: BoxColors = BoxColors.BROWN_GREY;
  @Input() usingAspect: 'INITIAL' | 'MY_PROFILE' | 'INFRACTIONS' = 'INITIAL';
  @Input() completeUserData: Partial<CompleteUserData> = {};
  @Input() lastInfractionsData?: InfrigmentOfUser[];
  @Input() imageDimensions: 'default' | 'tiny' = 'default';

  sanitizedBase64Image: SafeUrl = '';
  birthDate?: Date;
  infractionsLinkPath: string = '/search/infraction';

  constructor(
    private domSanitizer: DomSanitizer,
  ) { }

  ngAfterContentChecked() {
    let base64Image = this.personData?.photo || this.completeUserData?.photo;
    base64Image = base64Image?.replace("'", '');
    if (base64Image) {
      this.sanitizedBase64Image = this.domSanitizer.bypassSecurityTrustUrl(base64Image);
    }
    if (this.completeUserData?.birthDate) {
      const birthDate = new Date(this.completeUserData?.birthDate);
      birthDate.setTime(birthDate.getTime() + ((birthDate.getTimezoneOffset() / 60) * 60 * 60 * 1000));
      this.birthDate = birthDate;
    }
    if (this.personData.id) {
      const ofuscatedData = ofuscate({ personId: this.personData.id });
      this.infractionsLinkPath = `/search/infraction/result/${ofuscatedData}/infractions`;
    }
  }

}
